/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert[_ngcontent-%COMP%]{background:#781b8e;color:#fff;padding:10px;margin-bottom:15px;border-radius:4px;display:flex;align-items:center}.alert[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-left:10px}.fieldProduct[_ngcontent-%COMP%]{margin-top:20px}.title-prioritze[_ngcontent-%COMP%]{height:32px;width:100%;color:#231d19;font-family:\"Itau Display\";font-size:22px;font-weight:300;letter-spacing:0;line-height:32px;margin-bottom:20px}"];
export { styles as styles };
